import { useOrder } from "./order";
import { createContext, useContext, useEffect, useState } from "react";
import { useRest, useRestCall } from "../common/rest";
import { useUser } from "./user";
import { CMainLoading } from "./cr.ui.slide";
import { useExt } from "./ext";

const ReportContext = createContext();
export function Report(props) {
    const { match } = props;
    const order = useOrder()
    const [deaths, setDeaths] = useState([])
    const [kills, setKills] = useState([])
    const [xp, setXp] = useState({})
    const [scars, setScars] = useState([])
    const [marked, updateMarked] = useState([])
    const [unitRewards, setUnitRewards] = useState(match.army.rewardsToAssign.map((r, idx) => { return { ...r } }))
    const [call, loading] = useRestCall(order.reload)
    const [custom, setCustom] = useState({})

    function setDeath(id, k) {
        if (k) {
            setDeaths([...deaths, id])
        } else {
            setDeaths(deaths.filter(a => a !== id))
        }
        setScars(scars.filter(s => deaths.includes(s.id)))
    }

    function updateKills(id, u) {
        const upd = kills.filter(k => k !== id)
        for (let i = 0; i < u; i++) {
            upd.push(id)
        }
        setKills(upd)
    }

    function updateXp(id, u) {
        const upd = { ...xp }
        upd[id] = u
        setXp(upd)
    }

    function setMarked(id, k) {
        if (k) {
            if (marked.length < match.army.maxMarks) {
                updateMarked([...marked, id])
            }
        } else {
            updateMarked(marked.filter(a => a !== id))
        }
    }
    function setScar(id, s) {
        const upd = scars.filter(a => a.id !== id)
        if (s) {
            upd.push(s)
        }
        setScars(upd)
    }

    function assignUnitReward(rid, uid, val) {
        setUnitRewards(unitRewards.map(r => {
            if (r.id !== rid) {
                return r;
            }
            const edit = { ...r }
            if (val) {
                edit.selected = uid;
            } else {
                edit.selected = undefined;
            }
            return edit;
        }))
    }

    return <ReportContext.Provider
        value={{
            match,
            setDeath,
            deaths,
            kills,
            updateKills,
            xp,
            unitRewards,
            assignUnitReward,
            updateXp,
            marked,
            setMarked,
            loading,
            scars,
            setScar,
            call,
            custom,
            setCustom,
        }}
        {...props}
    />
}

export function useReport() {
    const order = useOrder()
    const ext = useExt();
    const { call, match, setDeath, deaths, kills, updateKills, xp, unitRewards, assignUnitReward, updateXp, marked, setMarked, scars, setScar, loading, custom, setCustom } = useContext(ReportContext)

    const units = order.units.filter(u => match.army.units.includes(u.id))

    function submit() {
        call(ext.matchCall(order.crusade.id, match.id), {
            deaths,
            kills,
            marked,
            scars,
            xp,
            unitRewards,
            ...custom
        })
    }

    return {
        ...order,
        units,
        match,
        deaths,
        setDeath,
        kills,
        updateKills,
        marked,
        setMarked,
        scars,
        setScar,
        unitRewards,
        assignUnitReward,
        updateXp,
        custom,
        setCustom,

        submit,
        loading,
    }
}